<template>
  <div :id="`accept-` + applicant.match_id" class="applicant-link component pb-4" >
    <template v-if="!limitView || index < limitAmount">
      <div class="card">
        <router-link
          v-if="view"
          :to="{
            name: 'view-match',
            params: { id: applicant.match_id }
          }"
          title="Bekijk"
          class="card-body"
          v-ripple="'rgba(192, 189, 187, 0.35)'"
        >
          <div class="card-top-row">
            <div v-if="parseInt(applicant.is_interested)" class="recent">
              Recent benaderd
            </div>
            <div v-if="parseInt(applicant.is_interview_invited)" class="recent">
              Recent uitgenodigd
            </div>
            <div v-else-if="parseInt(applicant.percentage) && this.localStorageSubBranch !== '2'" class="match_percentage">
              {{ parseInt(applicant.percentage) }}% match
            </div>
          </div>
          <div class="applicant-card-image">
            <img v-if="applicant.avatar" :src="applicant.avatar" class="img-item" />
            <svg-icon v-else icon="person_male" class="img-item"/>
            <div class="sd-title bold">
              {{ applicant.firstname }}
            </div>
          </div>
          <div class="applicant-card-spec">
            <div v-if="this.localStorageSubBranch !== '2'">
              {{ getWorkingDays().totalMatchedDays }}/{{ getWorkingDays().totalDays }} dagen beschikb.
            </div>
            <div v-if="applicant.matching_subject">
             {{ applicant.matching_subject }}
            </div>
            <div v-if="applicant.matching_subject">
              {{ getEducationExperience() }}
            </div>
            <div class="achievements_container" v-if="applicant.applicant_achievements && applicant.applicant_achievements.length">
              <achievements :achievements="applicant.applicant_achievements" size="small"></achievements>
            </div>
          </div>
          <div v-if="applicant.accept">
            <router-link to title="Aannemen" class="btn btn-light btn-block">Aannemen</router-link>
          </div>
        </router-link>
      </div>
    </template>
    <template v-if="limitView == true && index == limitAmount">
        <router-link
          v-if="view"
          :to="{
            name: 'job-matches',
             params: { id: parseInt(jobId) }
          }"
          title="Bekijk"
          class="sd-button btn btn-all"
          v-ripple="'rgba(192, 189, 187, 0.35)'"
        >
          <svg-icon icon="suitcase" />
          <div class="sd-title bold">
            Bekijk alle matches
          </div>
        </router-link>
    </template>
  </div>
</template>

<script>
import Achievements from "@/components/Achievements";

export default {
  data: function() {
    return {
      education_experience: null,
      localStorageSubBranch: localStorage.getItem('subBranch') || null
    }
  },
  props: {
    applicant: Object,
    view: Boolean,
    matchOverview: Boolean,
    index_key: null,
    dayData: Object,
    limitView: {
      type: Boolean,
      default: false
    },
    index: Number,
    limitAmount: Number,
    jobId: Number
  },
  computed: {
    func() {
      const exp = JSON.parse(this.applicant.experience);
      if (typeof exp !== 'undefined' && typeof exp["position"] !== 'undefined' && exp["position"][0]) {
        return exp["position"][0];
      }
      return "-";
    }
  },
  methods: {
    getWorkingDays() {
      let totalDays = {},
        totalMatchedDays = 0,
        workingDates = 0,
        unmatched_reasons = 0;

      if(this.applicant.unmatched_reasons)
      {
        let temp_unmatched_reasons = JSON.parse(this.applicant.unmatched_reasons);

        if(temp_unmatched_reasons && temp_unmatched_reasons.dates)
          unmatched_reasons = temp_unmatched_reasons.dates.length;
      }

      workingDates = Object.keys(JSON.parse(JSON.parse(this.applicant.working_dates))).length;

      totalMatchedDays = workingDates - unmatched_reasons;

      totalDays = {
        'totalDays': workingDates,
        'totalMatchedDays': totalMatchedDays,
      };

      return totalDays;
    },
    getEducationExperience() {

      if(this.applicant.matching_education_level) {
        return this.applicant.matching_education_level
      }

      return null;
    },
    async onInterestedNotification(id) {
      this.$emit("notification", "comment");
      this.$emit("match-id-change", id, this.index_key);
    }
  },
  components: {
    Achievements
  }
};
</script>

<style scoped>
.applicant-link {
  height: 100%;
}

.applicant-link .card {
  height: 100%;
  border: 2px solid #F6F6F6;
  border-radius: 10px;
}

.applicant-link .card .card-body {
  height: 100%;
  color: #64513D;
}

.applicant-link .card-top-row {
  display: grid;
  grid-auto-flow: column;
  position: absolute;
  top: -15px;
  left: 0;
  width: 100%;
}

.applicant-link .card-top-row .match_percentage,
.applicant-link .card-top-row .recent {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border-radius: 10px;
  font-size: 12px;
  margin-left: 20px;
  font-weight: 400;
}

.applicant-link .card-top-row .match_percentage {
  height: 25px;
  width: 85px;
  background-color: #FFCD00;
}

.applicant-link .card-top-row .recent {
  height: 25px;
  width: 115px;
  background-color: #F6F6F6;
}

.applicant-link .applicant-card-image {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 10px;
}

.applicant-link .applicant-card-image .img-item {
  display: block;
  object-fit: cover;
  height: 40px;
  width: 40px;
  min-width: 40px;
  border-radius: 100px;
  border: 2px solid #F6F6F6;
}

.applicant-link .applicant-card-image .img-item /deep/svg {
  width: 100%;
  height: 100%;
  padding: 2px;
}

.applicant-link .applicant-card-image .sd-title {
  margin-left: 10px;
}

.applicant-link .applicant-card-spec > div {
  display: flex;
}

.applicant-link .applicant-card-spec /deep/ svg {
  min-width: 15px;
  width: 15px;
  height: 15px;
  margin-right: 5px;
  margin-top: 3px;
  color: #FFCD00;
}

.applicant-link .applicant-card-spec .achievements_container {
  margin-top: 15px;
}

.applicant-link .btn-all {
  background-color: #F6F6F6;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.applicant-link .btn-all /deep/.svg-container {
  margin-right: 10px;
}
</style>
